import { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import { Button } from 'react-bootstrap'

import { useAppDispatch, useAppSelector } from 'hooks/store'
import {
  getActiveTabCourseOrderItem,
  getActiveDiscInstUrlInfo,
  setShownCourseInstructionsTrue
} from 'reducers/activecourse/activecourseSlice'
import {
  UPDATE_ORDER_COURSE_INSTRUCTIONS_FLAG,
  UpdateOrderShownCourseInstructionsFlagVariables,
  UpdateOrderShownCourseInstructionsFlagResponse
} from 'share/mutations/courses'
import GoBackHeader from 'components/organisms/GoBackHeader'
import { mainCoursePagePath } from 'share/utils/courseUtils'
import { CourseType } from 'share/domain/course'
import { TwoBtnsContainer } from 'components/atoms/Layout'

import {
  CourseInstructionsContainer,
  CourseInstructionsContent
} from './styles'

const CourseInstructions: FC = () => {
  const history = useHistory()
  const dispatch = useAppDispatch()
  const activeCase = useAppSelector((state) => state.activeCase)
  const activeCourse = useAppSelector((state) => state.activeCourse)
  const course = useAppSelector(getActiveTabCourseOrderItem)
  const discInstUrlInfo = useAppSelector(getActiveDiscInstUrlInfo)

  const [updateCourseInstructionsFlag] = useMutation<
    UpdateOrderShownCourseInstructionsFlagResponse,
    UpdateOrderShownCourseInstructionsFlagVariables
  >(UPDATE_ORDER_COURSE_INSTRUCTIONS_FLAG)

  async function updateCourseInstructionsFlagHelper(): Promise<boolean> {
    let result = false
    try {
      const input = {
        flag: true,
        courseType: course ? course.courseType : CourseType.CreditCounseling,
        caseId:
          activeCase.matter && activeCase.matter.id ? activeCase?.matter.id : 0
      }

      const updateResult = await updateCourseInstructionsFlag({
        variables: { request: input }
      })
      if (
        updateResult.data?.orders.updateOrderShownCourseInstructionsFlag.success
      ) {
        result = true

        dispatch(setShownCourseInstructionsTrue(activeCourse.activeTab))
      }
    } catch (e) {
      result = false
    }

    return result
  }

  async function nextClick() {
    await updateCourseInstructionsFlagHelper()
    history.push(mainCoursePagePath())
  }

  async function handleBackButtonClick() {
    history.push({
      pathname: '/dashboard/courses'
    })
  }

  const courseNumber =
    activeCourse.activeTab.charAt(0).toUpperCase() +
    activeCourse.activeTab.slice(1)

  return (
    <>
      <GoBackHeader text={course?.providerName} />
      <CourseInstructionsContainer data-testid='course-instructions-page'>
        <h2 data-testid='course-instructions-header'>Course Instructions</h2>
        <CourseInstructionsContent
          data-testid='course-instructions-content'
          dangerouslySetInnerHTML={{
            __html: discInstUrlInfo?.instructions || ''
          }}
        />
        <TwoBtnsContainer>
          <Button
            variant='outline-secondary'
            onClick={handleBackButtonClick}
            data-testid='course-instructions-back-button'
          >
            Back
          </Button>
          <Button
            variant='primary'
            onClick={nextClick}
            data-testid='course-instructions-start-course-button'
          >
            {`Start the ${courseNumber} Course`}
          </Button>
        </TwoBtnsContainer>
      </CourseInstructionsContainer>
    </>
  )
}

export default CourseInstructions
